<script lang="ts">
  import { Right } from "$components/+shared/OVIcon";
  import OVIcon from "app/components/+shared/OVIcon/OVIcon.svelte";

  export let title = "";
  export let description = "";
  export let isDescriptionInline: boolean = true;
</script>

<div
  class="flex gap-1 text-left text-sm md:text-[13px]"
  class:flex-col={!isDescriptionInline}
  class:items-center={isDescriptionInline}
>
  {#if title}
    <span class="max-w-[30ch] truncate text-inherit">
      {title}
    </span>
  {/if}

  {#if description}
    {#if isDescriptionInline}
      <OVIcon icon={Right} size="w-3.5 h-3.5" class="text-neutral-300 dark:text-neutral-500" />
    {/if}
    <span class="line-clamp-2 max-w-[30ch] text-neutral-400 dark:dark:text-neutral-500">
      {description}
    </span>
  {/if}
</div>
